import { ReactNode } from 'react';

type StatisticCardProps = {
    title: string;
    description: string;
    value: number;
    icon: ReactNode;
    colour: 'indigo' | 'green' | 'blue' | 'pink' | 'orange' | 'red';
};

const styles = {
    indigo: 'text-indigo-600 dark:text-indigo-400',
    green: 'text-green-600 dark:text-green-400',
    blue: 'text-blue-600 dark:text-blue-400',
    pink: 'text-pink-600 dark:text-pink-400',
    orange: 'text-orange-600 dark:text-orange-400',
    red: 'text-red-600 dark:text-red-400',
};

function StatisticCard({ title, description, value, icon, colour }: StatisticCardProps): JSX.Element {
    return (
        <div className="rounded-[5px] border border-gray-200 bg-white dark:bg-white/[0.05] dark:border-white/[0.07] p-4">
            <div className="flex gap-x-2">
                <div className={`w-6 h-6 ${styles[colour]}`}>{icon}</div>
                <div className="grid">
                    <label className={`text-sm font-bold ${styles[colour]}`}>{title}</label>
                    <div className="flex gap-x-1 items-end">
                        <p className="text-4xl font-medium text-gray-800 dark:text-white">{value}</p>
                        <p className="text-base font-normal text-gray-600 dark:text-gray-400">{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StatisticCard;
